import useProjectBySlug from "components/common/hooks/useProjectBySlug";
import LoadingScreen from "components/common/layout/LoadingScreen";
import DataTypes from "components/dataTypesScreen/DataTypes";
import { WithProjectSlug } from "navigation/Paths";
import React from "react";
import { RouteComponentProps } from "react-router";
import styled from "style/themed";
import AppScreen from "./AppScreen";
import Loading from "./Loading";

const Screen = styled(AppScreen)`
  padding: ${({ theme }) => theme.margin.medium};
  flex-direction: column;
`;

const DataTypesScreen = ({ match }: RouteComponentProps<WithProjectSlug>) => {
  const { projectSlug } = match.params;
  const { project, loading } = useProjectBySlug(projectSlug);

  if (loading) {
    return <LoadingScreen />;
  }

  if (project) {
    return (
      <Screen>
        <React.Suspense fallback={<Loading />}>
          <DataTypes projectId={project.id} />
        </React.Suspense>
      </Screen>
    );
  }
  return null;
};

export default DataTypesScreen;
